// apps/cli/src/templates/render.ts

/** Generate a render.yaml for Render deployment */
export const renderYamlTemplate = (
  agentName: string,
) => `# Render Blueprint — raxd agent
# Generated by: rax deploy up --target render
# Docs: https://render.com/docs/blueprint-spec

services:
  - type: web
    name: raxd-${agentName}
    runtime: docker
    plan: starter
    region: oregon
    healthCheckPath: /health
    envVars:
      - key: PORT
        value: "3000"
      - key: ANTHROPIC_API_KEY
        sync: false
      - key: TAVILY_API_KEY
        sync: false
      - key: LLM_PROVIDER
        value: anthropic
      - key: LLM_MODEL
        value: claude-sonnet-4-20250514
    autoDeploy: true
    dockerCommand: ""
    disk:
      name: agent-data
      mountPath: /app/data
      sizeGB: 1
`;

/** Simpler render.yaml without disk (for stateless SDK mode) */
export const renderYamlSdkTemplate = (
  agentName: string,
) => `# Render Blueprint — raxd SDK server
# Generated by: rax deploy up --target render --mode sdk
# Docs: https://render.com/docs/blueprint-spec

services:
  - type: web
    name: raxd-${agentName}
    runtime: docker
    plan: starter
    region: oregon
    healthCheckPath: /health
    envVars:
      - key: PORT
        value: "3000"
      - key: ANTHROPIC_API_KEY
        sync: false
      - key: TAVILY_API_KEY
        sync: false
      - key: LLM_PROVIDER
        value: anthropic
      - key: LLM_MODEL
        value: claude-sonnet-4-20250514
    autoDeploy: true
`;
